export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/eslint.worker.4f46d238.worker.js");
}
